'use client';

import { __rest, __assign } from '../_virtual/_tslib.js';
import React__default, { useState, useRef, useEffect } from 'react';
import { Container, Header, HeaderContent, IconWrapper, CollapsibleContent, Content, ViewMoreButton } from './Collapse.css.js';
import ArrowDownIcon from '../Images/ArrowDownIcon/index.js';
import { getTextNodeHeight } from './helpers.js';

var BORDER_HEIGHT = 2;
var Collapse = function (_a) {
    var header = _a.header, _b = _a.className, className = _b === void 0 ? '' : _b, children = _a.children, _c = _a.collapse, collapse = _c === void 0 ? true : _c, custom = _a.custom, _d = _a.disableCollapsible, disableCollapsible = _d === void 0 ? false : _d, onTransitionEnd = _a.onTransitionEnd, restProps = __rest(_a, ["header", "className", "children", "collapse", "custom", "disableCollapsible", "onTransitionEnd"]);
    var _e = custom || {}, _f = _e.enable, customEnable = _f === void 0 ? false : _f, _g = _e.numberOfLines, numberOfLines = _g === void 0 ? 0 : _g, viewMoreText = _e.viewMoreText, _h = _e.enableViewMoreShadow, enableViewMoreShadow = _h === void 0 ? false : _h, _j = _e.alwaysShowViewMore, alwaysShowViewMore = _j === void 0 ? false : _j;
    var _k = useState(collapse), isCollapse = _k[0], setCollapse = _k[1];
    var _l = useState(false), enableViewMore = _l[0], setEnableViewMore = _l[1];
    var collapsibleContentRef = useRef(null);
    var contentRef = useRef(null);
    var prevValue = useRef(collapse);
    useEffect(function () {
        if (prevValue.current !== collapse) {
            setCollapse(collapse);
        }
    }, [collapse]);
    useEffect(function () {
        prevValue.current = isCollapse;
    }, [isCollapse]);
    useEffect(function () {
        var handleCollapseContent = function () {
            if (contentRef.current && collapsibleContentRef.current) {
                var collapsibleContentEl = collapsibleContentRef.current;
                /*
                 * Handle action if enable viewMoreShadow
                 * */
                var lineHeight = getTextNodeHeight(collapsibleContentEl.childNodes[0], customEnable).lineHeight;
                var contentHeight = contentRef.current.scrollHeight;
                if (isCollapse) {
                    var maxHeight = 0;
                    if (customEnable) {
                        maxHeight += lineHeight * numberOfLines + BORDER_HEIGHT;
                        collapsibleContentEl.style.maxHeight = maxHeight + 'px';
                        collapsibleContentEl.style.overflow = 'hidden';
                        if (alwaysShowViewMore) {
                            setEnableViewMore(true);
                            return;
                        }
                        if (contentHeight > lineHeight * numberOfLines) {
                            setEnableViewMore(true);
                        }
                        return;
                    }
                    collapsibleContentEl.style.maxHeight = '0';
                    collapsibleContentEl.style.opacity = '0';
                    return;
                }
                collapsibleContentEl.style.maxHeight = contentHeight + BORDER_HEIGHT + 'px';
                collapsibleContentEl.style.opacity = '1';
            }
        };
        if (collapse) {
            handleCollapseContent();
        }
        else {
            /*
             * Make sure font is loaded before we doing collapse content
             * Because, our content is almost text, and font is effected to the height of content
             * */
            document.fonts.ready.then(function () {
                handleCollapseContent();
            });
        }
    }, [isCollapse, collapse, customEnable, numberOfLines, children, alwaysShowViewMore]);
    var handleHeaderAction = function () {
        if (customEnable || disableCollapsible) {
            return;
        }
        setCollapse(function (prevState) { return !prevState; });
    };
    var handleCustomCollapseButton = function () {
        if (disableCollapsible) {
            return;
        }
        setCollapse(function (prevState) { return !prevState; });
    };
    var handleTransitionEnd = function (e) {
        onTransitionEnd && onTransitionEnd();
        !isCollapse && e.target.style.removeProperty('overflow');
    };
    return (React__default.createElement(Container, __assign({ className: className, customEnable: customEnable }, restProps),
        header ? (React__default.createElement(Header, { customEnable: customEnable, className: 'vnw-collapse-header' },
            React__default.createElement(HeaderContent, { customContent: customEnable, onClick: handleHeaderAction }, header),
            !customEnable ? (React__default.createElement(IconWrapper, { onClick: function () { return setCollapse(function (prevState) { return !prevState; }); }, isCollapse: isCollapse },
                React__default.createElement(ArrowDownIcon, { color: '#fff', thickness: 1 }))) : null)) : null,
        React__default.createElement(CollapsibleContent, { ref: collapsibleContentRef, onTransitionEnd: handleTransitionEnd, enableMaskImage: enableViewMoreShadow, isCollapse: isCollapse },
            React__default.createElement(Content, { ref: contentRef }, children)),
        customEnable && enableViewMore ? (React__default.createElement(ViewMoreButton, { onClick: handleCustomCollapseButton, className: 'vnw-custom-collapse-button' }, viewMoreText ? viewMoreText(isCollapse) : '')) : null));
};

export { Collapse as default };
//# sourceMappingURL=index.js.map
